// ESC/POS byte generation for 58mm BLE thermal printers
// Target: service 0xFF00, write characteristic 0xFF02

const ESC = 0x1B
const GS  = 0x1D
const LF  = 0x0A

const COLS = 32

const INIT          = [ESC, 0x40]
const CODEPAGE_1252 = [ESC, 0x74, 0x10]
const ALIGN_LEFT    = [ESC, 0x61, 0x00]
const ALIGN_CENTER  = [ESC, 0x61, 0x01]
const BOLD_ON       = [ESC, 0x45, 0x01]
const BOLD_OFF      = [ESC, 0x45, 0x00]
const HEIGHT2_ON    = [GS,  0x21, 0x01]
const HEIGHT2_OFF   = [GS,  0x21, 0x00]

const SPANISH = {
  'á':0xE1,'é':0xE9,'í':0xED,'ó':0xF3,'ú':0xFA,
  'Á':0xC1,'É':0xC9,'Í':0xCD,'Ó':0xD3,'Ú':0xDA,
  'ñ':0xF1,'Ñ':0xD1,'ü':0xFC,'Ü':0xDC,'¿':0xBF,'¡':0xA1,
}

function encodeText(str) {
  const out = []
  for (const ch of str) {
    const code = ch.charCodeAt(0)
    if (code < 128) out.push(code)
    else out.push(SPANISH[ch] ?? 0x3F)
  }
  return out
}

function textLine(str) {
  return [...encodeText(str), LF]
}

function separator() {
  return textLine('--------------------------------')
}

function cols2(left, right) {
  const maxLeft = COLS - right.length - 1
  const l = left.length > maxLeft ? left.slice(0, maxLeft - 1) + '…' : left.padEnd(maxLeft)
  return textLine(`${l} ${right}`)
}

function feedAndCut(lines = 4) {
  return [GS, 0x56, 0x42, lines]
}

const METODO_LABEL = {
  efectivo: 'Efectivo',
  tarjeta: 'Tarjeta',
  transferencia: 'Transf.',
  fiado: 'Fiado',
}

export function generarTicketBytes(venta, config, folio) {
  const buf = []
  const p = (arr) => buf.push(...arr)

  p(INIT)
  p(CODEPAGE_1252)

  // Nombre de la tienda (centrado, alto doble + bold)
  p(ALIGN_CENTER)
  p(HEIGHT2_ON)
  p(BOLD_ON)
  p(textLine((config.nombreTienda || 'Mi Tienda').slice(0, 32)))
  p(HEIGHT2_OFF)
  p(BOLD_OFF)

  // Folio y fecha
  p(textLine(`Folio: ${folio}`))
  const fecha = new Date(venta.fecha).toLocaleString('es-MX', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  })
  p(textLine(fecha))
  p(separator())

  // Productos
  p(ALIGN_LEFT)
  for (const item of venta.items) {
    const esKg = item.unidad === 'kg'
    const precio = esKg
      ? (item.precioFinal ?? item.precio * item.cantidad)
      : item.precio * item.cantidad
    const qty = esKg ? `${item.cantidad}kg` : `${item.cantidad}x`
    p(cols2(`${qty} ${item.nombre}`, `$${precio.toFixed(2)}`))
  }

  p(separator())

  // Total
  p(BOLD_ON)
  p(cols2('TOTAL', `$${venta.total.toFixed(2)}`))
  p(BOLD_OFF)
  p(separator())

  // Forma de pago
  p(cols2('Pago', METODO_LABEL[venta.metodoPago] ?? venta.metodoPago ?? 'Efectivo'))
  if (venta.metodoPago === 'efectivo' && venta.recibido != null) {
    p(cols2('Recibido', `$${Number(venta.recibido).toFixed(2)}`))
    p(cols2('Cambio', `$${Number(venta.cambio ?? 0).toFixed(2)}`))
  }
  if (venta.metodoPago === 'fiado' && venta.clienteNombre) {
    p(cols2('Cliente', venta.clienteNombre.slice(0, 20)))
  }

  p(separator())

  // Pie
  p(ALIGN_CENTER)
  p(textLine('Gracias por su compra'))

  p(feedAndCut(4))

  return new Uint8Array(buf)
}
